/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IWeatherAnalyticsMethods,
  WeatherAnalyticsService,
  IActivityListMethods,
  ActivityListService,
  SettingsService,
  ISettingsMethods,
} from "./components";

export type WeatherAnalyticsAgent = IHeaderMethods &
  ISettingsMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  // IFormatPolicyDetailMethods &
  // IFormatTimelineDetailMethods &
  IWeatherAnalyticsMethods &
  IActivityListMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    // new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    //  new FormatPolicyDetailService(),
    // new FormatTimelineDetailService(),
    new WeatherAnalyticsService(),
    new ActivityListService(),
    new SettingsService(),
  ];
};

export const getAgent = () => {
  return createAgent<WeatherAnalyticsAgent>({
    plugins: getPlugins(),
  });
};
